import { APIAxiosInstance } from '@core/utils/api-axios-instance'
import {
  createMutationKeys,
  createQueryKeys,
  mergeQueryKeys,
} from '@lukemorales/query-key-factory'
import { RequestTypes } from './requestTypes'

const documentEngineTemplateQueryKeys = createQueryKeys(
  'document-engine-template',
  {
    byTemplateId: ({
      organisationId,
      templateId,
    }: RequestTypes['getDocumentEngineTemplate']) => {
      return {
        queryKey: [organisationId, templateId],
        queryFn: async () => {
          const { data } = await APIAxiosInstance.get(
            `document-engine/${organisationId}/templates/${templateId}`,
          )
          return data
        },
      }
    },
  },
)

const documentEngineTemplateMutationKeys = createMutationKeys(
  'document-engine-template',
  {
    createDocumentEngineTemplate: {
      mutationKey: null,
      mutationFn: async ({
        organisationId,
        ...rest
      }: RequestTypes['createDocumentEngineTemplate']) => {
        const { data } = await APIAxiosInstance.post(
          `document-engine/${organisationId}/templates`,
          rest,
        )
        return data
      },
    },
    createDocumentEngineTemplateVersion: {
      mutationKey: null,
      mutationFn: async ({
        organisationId,
        ...rest
      }: RequestTypes['createDocumentEngineTemplateVersion']) => {
        const { data } = await APIAxiosInstance.post(
          `document-engine/${organisationId}/templates/versions`,
          rest,
        )
        return data
      },
    },
    updateDocumentEngineTemplateQueries: {
      mutationKey: null,
      mutationFn: async ({
        organisationId,
        templateId,
        versionId,
        ...rest
      }: RequestTypes['updateDocumentEngineTemplateQueries']) => {
        const { data } = await APIAxiosInstance.put(
          `document-engine/${organisationId}/templates/${templateId}/versions/${versionId}/queries`,
          rest,
        )
        return data
      },
    },
    updateDocumentEngineTemplateBypassStatus: {
      mutationKey: null,
      mutationFn: async ({
        organisationId,
        templateId,
        versionId,
        ...rest
      }: RequestTypes['updateDocumentEngineTemplateBypassStatus']) => {
        const { data } = await APIAxiosInstance.put(
          `document-engine/${organisationId}/templates/${templateId}/versions/${versionId}/bypass`,
          rest,
        )
        return data
      },
    },
    updateDocumentEngineTemplateExpiryStatus: {
      mutationKey: null,
      mutationFn: async ({
        organisationId,
        templateId,
        versionId,
        ...rest
      }: RequestTypes['updateDocumentEngineTemplateExpiryStatus']) => {
        const { data } = await APIAxiosInstance.put(
          `document-engine/${organisationId}/templates/${templateId}/versions/${versionId}/expiry`,
          rest,
        )
        return data
      },
    },
    updateDocumentEngineTemplate: {
      mutationKey: null,
      mutationFn: async ({
        organisationId,
        templateId,
        ...rest
      }: RequestTypes['updateDocumentEngineTemplate']) => {
        const { data } = await APIAxiosInstance.put(
          `document-engine/${organisationId}/templates/${templateId}`,
          rest,
        )
        return data
      },
    },
    deleteDocumentEngineTemplate: {
      mutationKey: null,
      mutationFn: async ({
        organisationId,
        templateId,
      }: RequestTypes['deleteDocumentEngineTemplate']) => {
        const { data } = await APIAxiosInstance.delete(
          `document-engine/${organisationId}/templates/${templateId}`,
        )
        return data
      },
    },
  },
)

export const documentEngineTemplateKeys = mergeQueryKeys(
  documentEngineTemplateQueryKeys,
  documentEngineTemplateMutationKeys,
)['document-engine-template']
